import { useLazyQuery } from "@apollo/client";
import { GET_ENV_VALUES } from "../../Routes/query";
import {
  setBannerMessages,
  setEnvFlags,
  setPaymentAmounts,
  setRouterCodes,
} from "../../Redux/Slices/UserSlice";
import { useDispatch } from "react-redux";
import { parseCommaSeparatedString } from "../../Services/helper";

const useEnvApiCalls = () => {
  const dispatch = useDispatch();

  const [getEnvValues, { loading: getEnvValuesLoading }] = useLazyQuery(GET_ENV_VALUES, {
    variables: {
      platform: process.env.REACT_APP_ENV_PLATFORM,
    },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const variables = data?.getEnvValuesFromFirestore?.envVariables;
      dispatch(setEnvFlags(variables));
      dispatch(setBannerMessages(data?.getEnvValuesFromFirestore?.allBannerMessages || []));
      dispatch(setPaymentAmounts(data?.getEnvValuesFromFirestore?.paymentAmounts || []));
      const routerCodesArray = parseCommaSeparatedString(
        data?.getEnvValuesFromFirestore?.routerCodes
      );
      dispatch(setRouterCodes(routerCodesArray));
    },
  });

  return { getEnvValues, getEnvValuesLoading };
};

export default useEnvApiCalls;
